// 路由映射
const routerMap = {
  // 供应商产品库
  '/goods/store': { pageId: 4187, name: '供应商商品库' },
  '/goods/new': { pageId: 4188, name: '新增商品' },
  '/goods/cert': { pageId: 4189, name: '商品资质' },

  // 订单信息
  '/order/notConfirmed': { pageId: 4190, name: '订单-待确认' },
  '/order/preDeliverGoods': { pageId: 4191, name: '订单-待预约' },
  '/order/deliverGoods': { pageId: 4192, name: '订单-已预约' },
  '/order/confirmStockYes': { pageId: 4193, name: '订单-待入库' },
  '/order/allReadyInstock': { pageId: 4194, name: '订单-已入库' },
  '/order/allReadyReturn': { pageId: 4195, name: '订单-已退货' },
  '/order/exceptionPurchaseOrder': { pageId: 4196, name: '订单-异常订单' },

  // 合同管理
  '/contract/contract': { pageId: 4197, name: '合同管理-我的合同' },
  '/contract/signImage': { pageId: 4198, name: '合同管理-我的印章' },

  // 资质管理
  '/certManage/baseCert': { pageId: 4199, name: '订单-已入库' },
  '/certManage/expandCert': { pageId: 4200, name: '订单-已入库' },

  // 直送
  '/price/confirm': { pageId: 4201, name: '直送-待出库' },
  '/price/deliver': { pageId: 4202, name: '直送-配送中' },
  '/price/finish': { pageId: 4203, name: '直送-已完成' },
  '/price/cancel': { pageId: 4204, name: '直送-已取消' },

  // 报价
  '/price/current': { pageId: 4205, name: '商品报价-当前价格' },
  '/price/quote': { pageId: 4206, name: '商品报价-报价' },

  // 账单管理
  '/billManage/billAll': { pageId: 4207, name: '账单管理-全部' },
  '/billManage/billConfirm': { pageId: 4208, name: '账单管理-待确认' },
  '/billManage/billObjection': { pageId: 4211, name: '账单管理-异议账单' },
  '/billManage/billWait': { pageId: 4209, name: '账单管理-待收款' },
  '/billManage/billAlready': { pageId: 4210, name: '账单管理-已收款' },

  // 自测
  // 单据管理
  '/orderManagement/adjustOrder': { pageId: 4212, name: '单据管理-调整单' },
  '/orderManagement/returnOrder': { pageId: 4213, name: '单据管理-退货单' },
  '/orderManagement/penaltyOrder': { pageId: 4214, name: '单据管理-罚款单' },
  '/orderManagement/contractFeeOrder': { pageId: 4215, name: '单据管理-费用管理' },
  // '/orderManagement/compensate': { pageId: 4216, name: '单据管理-进价补偿单' },
  '/orderManagement/serviceOrder': { pageId: 4217, name: '单据管理-服务费' },

  // 发票管理
  '/invoice/maintain': { pageId: 4221, name: '发票管理-维护发票' },
  '/invoice/manage': { pageId: 4222, name: '发票管理-管理发票' },

  // 钱包
  '/mergeInvoice/create': { pageId: 4223, name: '合并开票-生成发票' },
  '/mergeInvoice/maintainPaper': { pageId: 4224, name: '合并开票-维护发票' },
  '/mergeInvoice/manage': { pageId: 4225, name: '合并开票-管理发票' },
  '/mergeInvoice/maintainYihai': { pageId: 4226, name: '合并开票-融合发票维护' },
  '/mergeInvoice/accountStatement': { pageId: 4227, name: '合并开票-对账单' },

  // 合并开票
  //'/finance/balance': { pageId: 4228, name: '钱包-余额查询' },
  '/finance/marketingFee': { pageId: 4229, name: '钱包-营销费查询' },
  '/finance/selfMarketingFee': { pageId: 4546, name: '钱包-自营营销费管理' },

  // 下载中心
  '/download/downloadApp': { pageId: 4230, name: '下载中心' },

  // '/visit/list': { pageId: 4233, name: '联合拜访' },
  // '/visit/dataBoard': { pageId: 4234, name: '拜访数据' },

  // 帮助中心
  '/help/problem': { pageId: 4231, name: '常见问题' },
  '/help/feedback': { pageId: 4232, name: 'CEO直通车' }
}
export default routerMap



// WEBPACK FOOTER //
// ./src/tracer/routeMap.js